import { Component, EventEmitter, Output } from '@angular/core';
import { environment } from '@env/environment.local';

@Component({
    selector: 'instagram-empty-state',
    templateUrl: 'instagram-empty-state.component.html',
    styleUrls: ['instagram-empty-state.component.scss'],
})
export class InstagramEmptyStateComponent {
    assetsUrl: string = environment.assets_url;
    mfsPath: string = environment.mfs_path;
    @Output() login: EventEmitter<boolean> = new EventEmitter();

    constructor() {}

    instagramLogin(): void {
        this.login.emit(true);
    }
}
